import getSelectsOptions from '../../../modals/editSimcard/actions/getSelectsOptions';

const watchSimCards = [getSelectsOptions];

export default watchSimCards;
